export const REACT_APP_APIURL = process.env.REACT_APP_APIURL;
